// @ts-strict-ignore
import styled from 'styled-components';

import { FilestackImage } from 'components/Image';
import { BodySmall } from 'components/Text/BodySmall';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { getIsContentFullWidthLayout } from 'modules/cms/helpers';
import { colors } from 'theme';

const HeaderImage = styled.div`
  img {
    height: 100%;
    width: 100%;
  }
`;

type Props = {
  content: CmsApiPage;
};

export function CmsHeaderImage({ content }: Props) {
  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    <HeaderImage>
      <FilestackImage
        data-qa-id="cms-page-header-image"
        data={content.headerImage}
        width={fullWidthLayout ? 1152 : 952}
        alt={
          content.headerImage.altText
            ? content.headerImage.altText
            : content.title
        }
      />
      {content.headerImage.caption && (
        <BodySmall color={colors.battleshipGrey} mt="8px">
          {content.headerImage.caption}
        </BodySmall>
      )}
    </HeaderImage>
  );
}
